import { useEffect, useRef, useState } from 'react';
import { Input } from './styles';
import { Button, Flex, InputRef, Space, Tooltip } from 'antd';
import { CloseOutlined, EditOutlined, SaveFilled } from '@ant-design/icons';
import { useRecapManagement } from '../../../../../recapv2/recap-management/hook';
import { useToast } from '../../../../../../hooks/useToast';

export const EditableTitle = () => {
  const { changeTitle, title, isPublic, permissions } = useRecapManagement();
  const [temporalTitle, setTemporalTitle] = useState(title || 'Default title');
  const { success, error } = useToast();
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    setTemporalTitle(title);
  }, [title]);

  const editTitleFeatureAvailable = !isPublic && permissions.canChangeMeetingTitle;

  const handleTitleChanged = (title: string) => {
    setTemporalTitle(title);
  };

  const handleSave = () => {
    setIsSaving(true);
    changeTitle(temporalTitle)
      .then(() => {
        success(`Meeting title updated`);
      })
      .catch(() => error(`There was an error updating meeting title`))
      .finally(() => {
        setIsSaving(false);
        setIsEditing(false);
      });
  };

  return (
    <Space
      style={{
        display: 'flex',
        alignContent: 'center',
        maxWidth: '600px',
        justifyContent: 'space-between',
      }}
    >
      <Input
        ref={inputRef}
        placeholder={title}
        value={temporalTitle}
        bordered={false}
        onChange={e => handleTitleChanged(e.target.value)}
        onFocus={() => {
          if (editTitleFeatureAvailable) {
            setIsEditing(true);
          }
        }}
      />
      {!isEditing && (
        <Tooltip
          title={!editTitleFeatureAvailable ? "You don't have permission to edit this info" : null}
        >
          <Button
            disabled={!editTitleFeatureAvailable}
            icon={<EditOutlined />}
            shape="round"
            size="small"
            onClick={() => {
              setIsEditing(true);
              inputRef.current?.focus();
            }}
          />
        </Tooltip>
      )}
      {isEditing && (
        <Flex gap={4}>
          <Button
            icon={<CloseOutlined />}
            shape="round"
            size="small"
            onClick={() => setIsEditing(false)}
          />

          <Tooltip title={'Save'}>
            <Button
              type="primary"
              shape="round"
              size="small"
              loading={isSaving}
              disabled={!isEditing}
              onClick={() => {
                handleSave();
              }}
            >
              <SaveFilled />
            </Button>
          </Tooltip>
        </Flex>
      )}
    </Space>
  );
};
